/** MtvNodeType
 * generated by enums.tst
**/
var MtvNodeType;
(function (MtvNodeType) {
    MtvNodeType[MtvNodeType["brand"] = 0] = "brand";
    MtvNodeType[MtvNodeType["sim"] = 1] = "sim";
    MtvNodeType[MtvNodeType["suite"] = 2] = "suite";
    MtvNodeType[MtvNodeType["test"] = 3] = "test";
})(MtvNodeType || (MtvNodeType = {}));
/** MtResultType
 * generated by enums.tst
**/
var MtResultType;
(function (MtResultType) {
    MtResultType[MtResultType["PassPass"] = 0] = "PassPass";
    MtResultType[MtResultType["PassNoVerdict"] = 1] = "PassNoVerdict";
    MtResultType[MtResultType["PassInconclusive"] = 2] = "PassInconclusive";
    MtResultType[MtResultType["PassFail"] = 3] = "PassFail";
    MtResultType[MtResultType["FailInconclusive"] = 4] = "FailInconclusive";
    MtResultType[MtResultType["FailFail"] = 5] = "FailFail";
    MtResultType[MtResultType["FailPass"] = 6] = "FailPass";
    MtResultType[MtResultType["FailNoVerdict"] = 7] = "FailNoVerdict";
    MtResultType[MtResultType["Incomplete"] = 8] = "Incomplete";
    MtResultType[MtResultType["NotHandled"] = 9] = "NotHandled";
    MtResultType[MtResultType["NoVerdict"] = 10] = "NoVerdict";
    MtResultType[MtResultType["NoneFail"] = 11] = "NoneFail";
    MtResultType[MtResultType["NoneInconclusive"] = 12] = "NoneInconclusive";
    MtResultType[MtResultType["NonePass"] = 13] = "NonePass";
})(MtResultType || (MtResultType = {}));
